import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=a7b152e2&"
import script from "./DialogForm.vue?vue&type=script&lang=js&"
export * from "./DialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7b152e2')) {
      api.createRecord('a7b152e2', component.options)
    } else {
      api.reload('a7b152e2', component.options)
    }
    module.hot.accept("./DialogForm.vue?vue&type=template&id=a7b152e2&", function () {
      api.rerender('a7b152e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogForm/DialogForm.vue"
export default component.exports